import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    ScrollView,
    TextInput
} from "react-native";

import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Text from "../components/Text";
import * as Constants from "../utils/Constants";
import * as Animatable from "react-native-animatable";
import * as ServerOperations from "../utils/ServerOperations";
import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();

let styles = {};
let isMobile = false;
let scale = 1;
const backChevron = require("../images/login/backChevron.png");
const imgJordanLogo = require("../images/login/jdsJordan.png");
const imgJdsLogo = require("../images/Header/JdsLogo.png");
const imgHelpIcon = require("../images/Header/helpIcon.png");
class OtpVerification extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isScrolled: false,
            falseOtpCode: false,
            timerMinutes: 1,
            timerSeconds: 0,
            loginButtonStyle: AppStyles.secondaryButtonStyleOpacity,
            failedAttemps: false,
        };
    }
    Pressables = {};

    async componentDidMount() {
        this.startTimer();
    }

    startTimer = () => {
        this.setState({ timerMinutes: 1, timerSeconds: 0 });
        this.timerInterval = setInterval(() => {
            const { timerMinutes, timerSeconds } = this.state;
            if (timerSeconds > 0) {
                this.setState({ timerSeconds: timerSeconds - 1 });
                if (timerSeconds == 30) { this.setState({ loginButtonStyle: AppStyles.loginButtonStyles }) }
            } else if (timerMinutes > 0) {
                this.setState({ timerMinutes: timerMinutes - 1, timerSeconds: 59 });
            } else {
                clearInterval(this.timerInterval);
            }
        }, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.timerInterval);
    }

    renderFailedAttempts = () => {
        return (
            <Animatable.View
                animation="slideInUp"
                duration={500}
                style={{
                    width: width - 20,
                    height: 475,
                    position: 'absolute',
                    top: '22%',
                    // left: '50%',
                    transform: [{ translateX: -(width - 20) / 2 }, { translateY: -237.5 }],
                    zIndex: 1000,
                    flexDirection: 'column',
                    backgroundColor: 'white',
                    alignItems: 'center',
                    gap: 32,
                }}>
                <View style={{ display: 'flex', marginTop: 32, flexDirection: 'column', alignItems: 'center', gap: 8, alignSelf: 'stretch' }}>
                    <View style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', alignSelf: 'stretch', width: width - 40 }}>
                        <Text style={[AppStyles.H1Styles, { textAlign: 'center' }]}>{STRINGS.Too_Many_Failed_Attempts}</Text>
                    </View>
                    <View style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', alignSelf: 'stretch', width: width - 40 }}>
                        <Text style={[AppStyles.SecondaryTextStyles, { textAlign: 'center', marginTop: 30 }]}>{STRINGS.Too_Many_Failed_Attempts_Message}</Text>
                    </View>
                </View>
            </ Animatable.View>
        )
    };

    renderHeader = () => {
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', padding: 20, alignSelf: "stretch", justifyContent: "space-between" }}>
                <TouchableOpacity onPress={() => window.history.back()} style={{ paddingHorizontal: isMobile ? undefined : 64 }}>
                    <Image source={imgJdsLogo} style={{
                        width: 35.063,
                        height: 37,
                        padding: 1,
                        resizeMode: "contain",
                    }} />
                </TouchableOpacity>
                <TouchableOpacity onPress={() => this.setState({ showModal: true })} style={{ paddingRight: isMobile ? undefined : 64 }}>
                    <Image source={imgHelpIcon} style={{ width: 19.2, height: 19.2 }} />
                </TouchableOpacity>
            </View>
        )
    }



    renderMobile() {
        scale = width / 420;
        return (
            <View style={styles.container}>
                <ScrollView
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    <View style={{ width, paddingHorizontal: 20 }}>
                        {Commons.loadFonts(this, false)}
                        {Styles.renderVSeparator(0)}
                        {this.renderPart1Mobile()}
                        {this.state.failedAttemps == true && this.renderFailedAttempts()}
                        {/* {this.renderPart2Mobile()} */}
                        {/* {Commons.renderFooter({}, this)} */}
                    </View>
                </ScrollView >
            </View >
        );
    }

    render() {
        Commons.resizeHandle(window, this, () => {
            width = this.width;
            height = this.height;
        });
        width = Dimensions.get("window").width;
        height = Dimensions.get("window").height;
        isMobile = Commons.isMobile();
        if (isMobile) {
            styles = this.styles();
            return this.renderMobile();
        }
        styles = this.styles();
        return (
            <View style={styles.container}>
                {this.renderHeader()}
                {Commons.loadFonts(this, false)}
                {this.renderPart1()}
            </View >
        );
    }

    renderPart1 = () => {
        return (
            <View style={{ width, height: height - 90, backgroundColor: '#FFF', alignItems: 'center', justifyContent: 'center' }}>
                <View style={{ position: 'absolute', bottom: 0, right: 30 }}>
                    <Image source={imgJordanLogo} style={{ width: 400, height: 500 }} />
                </View>
                <View style={{ width: 375, alignSelf: 'center', borderRadius: 10, borderWidth: 1, borderColor: 'rgba(59, 98, 127, 0.20)', backgroundColor: '#FFF' }}>
                    <View style={{ display: "flex", flexDirection: "column", alignItems: "center", alignSelf: "stretch", gap: 8 }}>
                        <View style={{ display: "flex", alignItems: "center", justifyContent: "center", alignSelf: "stretch", marginTop: 50 }}>
                            <Text style={[AppStyles.H1Styles, { fontSize: 28 }]}>{STRINGS.OTP_Code_Verification}</Text>
                        </View>
                        <View style={{ display: 'flex', paddingVertical: 24, justifyContent: 'center', alignItems: 'center', alignSelf: 'stretch' }}>
                            <Text style={[AppStyles.H1Styles]}>
                                {this.state.timerMinutes}:{this.state.timerSeconds < 10 ? `0${this.state.timerSeconds}` : this.state.timerSeconds}
                            </Text>
                        </View>

                        <Text style={[AppStyles.SecondaryTextStyles, { textAlign: 'center' }]}>
                            {STRINGS.Verification_Phone_number}
                        </Text>
                        {(this.state.falseOtpCode == false) && (
                            <View style={[AppStyles.OtpViewStyle]}>
                                <TextInput
                                    style={[AppStyles.OtpCodeInput3]}
                                    value={this.state.otpCode1}
                                    keyboardType="numeric"
                                    maxLength={1}
                                    autoFocus
                                    onChangeText={(text) => {
                                        if (text.length === 1) {
                                            this.setState({ otpCode1: text });
                                            this.Pressables[1].focus();
                                        }
                                    }}
                                    ref={(input) => { this.Pressables[0] = input; }}
                                />
                                <TextInput
                                    style={[AppStyles.OtpCodeInput3]}
                                    value={this.state.otpCode2}
                                    keyboardType="numeric"
                                    maxLength={1}
                                    onChangeText={(text) => {
                                        if (text.length === 1) {
                                            this.setState({ otpCode2: text });
                                            this.Pressables[2].focus();
                                        }
                                    }}
                                    ref={(input) => { this.Pressables[1] = input; }}
                                />
                                <TextInput
                                    style={[AppStyles.OtpCodeInput3]}
                                    value={this.state.otpCode3}
                                    keyboardType="numeric"
                                    maxLength={1}
                                    onChangeText={(text) => {
                                        if (text.length === 1) {
                                            this.setState({ otpCode3: text });
                                            this.Pressables[3].focus();
                                        }
                                    }}
                                    ref={(input) => { this.Pressables[2] = input; }}
                                />
                                <TextInput
                                    style={[AppStyles.OtpCodeInput3]}
                                    value={this.state.otpCode4}
                                    keyboardType="numeric"
                                    maxLength={1}
                                    ref={(input) => { this.Pressables[3] = input; }}
                                    onChangeText={(text) => {
                                        if (text.length === 1) {
                                            loaderHandler.showLoader(STRINGS.loading, this);
                                            this.setState({ otpCode4: text });
                                            this.checkOtpVerificationNumber();
                                        }
                                    }}
                                />
                            </View>
                        )}

                        {(this.state.falseOtpCode == true) && (
                            <View style={[AppStyles.OtpViewStyle]}>
                                <TextInput
                                    style={[AppStyles.OtpCodeInput4]}
                                    value={this.state.otpCode1}
                                    keyboardType="numeric"
                                    autoFocus
                                    maxLength={1}
                                    onChangeText={(text) => {
                                        if (text.length === 1) {
                                            this.setState({ otpCode1: text });
                                            this.Pressables[1].focus();
                                        }
                                    }}
                                    ref={(input) => { this.Pressables[0] = input; }}
                                />
                                <TextInput
                                    style={[AppStyles.OtpCodeInput4]}
                                    value={this.state.otpCode2}
                                    keyboardType="numeric"
                                    maxLength={1}
                                    onChangeText={(text) => {
                                        if (text.length === 1) {
                                            this.setState({ otpCode2: text });
                                            this.Pressables[2].focus();
                                        }
                                    }}
                                    ref={(input) => { this.Pressables[1] = input; }}
                                />
                                <TextInput
                                    style={[AppStyles.OtpCodeInput4]}
                                    value={this.state.otpCode3}
                                    keyboardType="numeric"
                                    maxLength={1}
                                    onChangeText={(text) => {
                                        if (text.length === 1) {
                                            this.setState({ otpCode3: text });
                                            this.Pressables[3].focus();
                                        }
                                    }}
                                    ref={(input) => { this.Pressables[2] = input; }}
                                />
                                <TextInput
                                    style={[AppStyles.OtpCodeInput4]}
                                    value={this.state.otpCode4}
                                    keyboardType="numeric"
                                    maxLength={1}
                                    ref={(input) => { this.Pressables[3] = input; }}
                                    onChangeText={(text) => {
                                        if (text.length === 1) {
                                            this.setState({ otpCode4: text });
                                            this.checkOtpVerificationNumber();
                                        }
                                    }}
                                />
                            </View>
                        )}
                        {(this.state.falseOtpCode == true) && (
                            <Text style={[AppStyles.SecondaryTextStyles, { color: '#D70202' }]}>{STRINGS.Otp_Error_Message}</Text>
                        )}

                        <TouchableOpacity style={[this.state.loginButtonStyle, { width: 342, marginTop: 50, marginHorizontal: 16 }]}
                            onPress={() => {
                                this.setState({ failedAttemps: true })
                                loaderHandler.showLoader(STRINGS.loading, this);
                                // this.checkCustomerPhone();
                                this.checkOtpVerificationNumber();
                            }}>
                            <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.Resend_Code}</Text>
                        </TouchableOpacity>
                        <Text style={[AppStyles.SecondaryTextStyles, { textAlign: 'center', marginTop: 8, marginBottom: 50 }]}>
                            {STRINGS.Resending_Otp}
                        </Text>

                    </View>
                </View>
            </View>
        )
    }

    renderPart1Mobile = () => {
        // Helper to handle OTP input change and focus
        const handleOtpChange = (index, text) => {
            const otpFields = ['otpCode1', 'otpCode2', 'otpCode3', 'otpCode4'];
            let newState = {};
            newState[otpFields[index]] = text;

            this.setState(newState, () => {
                if (text.length === 1 && index < 3) {
                    this.Pressables[index + 1]?.focus();
                }
                if (text.length === 0 && index > 0) {
                    this.Pressables[index - 1]?.focus();
                }
                // If last field and filled, trigger verification
                if (index === 3 && text.length === 1) {
                    loaderHandler.showLoader(STRINGS.loading, this);
                    this.checkOtpVerificationNumber();
                }
            });
        };

        // Helper to handle backspace navigation
        const handleOtpKeyPress = (index, nativeEvent) => {
            if (nativeEvent.key === 'Backspace') {
                const otpFields = ['otpCode1', 'otpCode2', 'otpCode3', 'otpCode4'];
                if (!this.state[otpFields[index]] && index > 0) {
                    this.Pressables[index - 1]?.focus();
                }
            }
        };

        return (
            <View
                style={{
                    width: width - 20,
                    flexDirection: 'column',
                    backgroundColor: 'white',
                    alignItems: 'center',
                    gap: 16,
                    justifyContent: 'center'
                }}
            >
                <View style={{ display: 'flex', width: width - 40, height: 75, alignItems: 'center', flexShrink: 0, backgroundColor: '#FFF', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <TouchableOpacity
                        onPress={() => window.location = './login'}
                        style={{ marginLeft: 0 }}>
                        <Image source={backChevron} style={{ width: 9.6, height: 8.8 }}></Image>
                    </TouchableOpacity>
                    <Text style={[AppStyles.H3Styles,]}>
                        {STRINGS.OTP_Code_Verification}
                    </Text>
                    <Text></Text>
                </View>

                <View style={{ display: 'flex', paddingVertical: 32, flexDirection: 'column', alignItems: 'center', gap: 8, alignSelf: 'stretch', width: width - 40 }}>
                    <View style={{ display: 'flex', paddingVertical: 24, justifyContent: 'center', alignItems: 'center', alignSelf: 'stretch' }}>
                        <Text style={[AppStyles.H1Styles]}>
                            {this.state.timerMinutes}:{this.state.timerSeconds < 10 ? `0${this.state.timerSeconds}` : this.state.timerSeconds}
                        </Text>
                    </View>

                    <Text style={[AppStyles.SecondaryTextStyles, { textAlign: 'center' }]}>
                        {STRINGS.Verification_Phone_number}
                    </Text>

                    <View style={[AppStyles.OtpViewStyle]}>
                        {[0, 1, 2, 3].map((idx) => {
                            const otpFields = this.state.falseOtpCode
                                ? [AppStyles.OtpCodeInput4, AppStyles.OtpCodeInput4, AppStyles.OtpCodeInput4, AppStyles.OtpCodeInput4]
                                : [AppStyles.OtpCodeInput3, AppStyles.OtpCodeInput3, AppStyles.OtpCodeInput3, AppStyles.OtpCodeInput3];
                            return (
                                <TextInput
                                    key={idx}
                                    style={otpFields[idx]}
                                    value={this.state[`otpCode${idx + 1}`]}
                                    keyboardType="numeric"
                                    maxLength={1}
                                    autoFocus={idx === 0}
                                    onChangeText={(text) => handleOtpChange(idx, text)}
                                    onKeyPress={({ nativeEvent }) => handleOtpKeyPress(idx, nativeEvent)}
                                    ref={(input) => { this.Pressables[idx] = input; }}
                                />
                            );
                        })}
                    </View>

                    {this.state.falseOtpCode === true && (
                        <Text style={[AppStyles.SecondaryTextStyles, { color: '#D70202' }]}>{STRINGS.Otp_Error_Message}</Text>
                    )}

                    <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, alignSelf: 'stretch', width: width - 40, marginTop: 60 }}>
                        <TouchableOpacity style={this.state.loginButtonStyle}
                            onPress={() => {
                                this.setState({ failedAttemps: true })
                                loaderHandler.showLoader(STRINGS.loading, this);
                                // this.checkCustomerPhone();
                                this.checkOtpVerificationNumber();
                            }}>
                            <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.Resend_Code}</Text>
                        </TouchableOpacity>
                        <Text style={[AppStyles.SecondaryTextStyles, { textAlign: 'center', marginTop: 8 }]}>
                            {STRINGS.Resending_Otp}
                        </Text>
                    </View>
                </View>
            </View>
        )
    }

    checkCustomerPhone = async () => {
        const customerCode = await Commons.getFromAS(Constants.CUST_CODE);
        const phone = await Commons.getFromAS(Constants.PHONE);
        const resp = await ServerOperations.checkCustomerPhone(customerCode, phone);
        if (resp.ERROR) {
            setTimeout(() => {
                loaderHandler.hideLoader();
            }, 300);
            return;
        }
        setTimeout(() => {
            loaderHandler.hideLoader();
            window.location = './OtpVerification';
        }, 1500);
    };

    checkOtpVerificationNumber = async () => {
        const customerCode = await Commons.getFromAS(Constants.CUST_CODE);
        const phone = await Commons.getFromAS(Constants.PHONE);
        const otpCode = this.state.otpCode1 + this.state.otpCode2 + this.state.otpCode3 + this.state.otpCode4;
        const resp = await ServerOperations.login(customerCode, phone, otpCode);
        if (resp.ERROR) {
            this.setState({ falseOtpCode: true, otpCode1: '', otpCode2: '', otpCode3: '', otpCode4: '' });
            setTimeout(() => {
                loaderHandler.hideLoader();
            }, 300);
            return;
        }
        this.setState({ falseOtpCode: false });
        const token = resp.TOKEN;
        Commons.saveToAS(Constants.TOKEN, token);
        setTimeout(() => {
            loaderHandler.hideLoader();
            // window.location = './ClientHomePage';
            this.props.navigation.navigate("shop");
        }, 1500);
    }


    styles = () => ({
        container: {
            flex: 1,
            width: width,
            alignItems: "center",
            backgroundColor: WHITE
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            width,
            height: 590,
        }
    });
}

export default OtpVerification;
